export default __webpack_public_path__ + "static/media/sidebar-6.7ee52f40.jpg";